module.exports = __webpack_public_path__ + "img/price-1790.47b3298f.png";